/*
 *
 * Documents Actions
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 08-Nov-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_NEW_DOCUMENTS: '@@Documents/get_new_documents',
  DO_GET_BANK_STATEMENTS: '@@Documents/get_bank_statements',
  DO_GET_INVOICES: '@@Documents/get_invoices',
  DO_GET_TAX_CREDIT: '@@Documents/get_tax_credit',
  DO_GET_OTHER_DOCUMENTS: '@@Documents/get_other_documents',
  DO_GET_TABS: '@@Documents/get_tabs',
  DO_GET_DOWNLOAD: '@@Documents/get_other_download',
  DO_RESET_DOWNLOAD: '@@Documents/reset_download',

  // @generator action:route:type
  ...createRequestTypes('@@Documents', 'GET_NEW_DOCUMENTS'),
  ...createRequestTypes('@@Documents', 'GET_BANK_STATEMENTS'),
  ...createRequestTypes('@@Documents', 'GET_INVOICES'),
  ...createRequestTypes('@@Documents', 'GET_TAX_CREDIT'),
  ...createRequestTypes('@@Documents', 'GET_OTHER_DOCUMENTS'),
  ...createRequestTypes('@@Documents', 'GET_TABS'),
  ...createRequestTypes('@@Documents', 'GET_DOWNLOAD')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name getNewDocuments
 * @return {object} - The action object
 */
export const getNewDocuments = new MakeRequest('Documents', 'get_new_documents')
/** @action request
 * * Insert a description
 * @name getDownload
 * @return {object} - The action object
 */
export const getDownload = new MakeRequest('Documents', 'get_download')
/** @action request
 * * Insert a description
 * @name getTabs
 * @return {object} - The action object
 */
export const getTabs = new MakeRequest('Documents', 'get_tabs')
/** @action request
 * * Insert a description
 * @name getOtherDocuments
 * @return {object} - The action object
 */
export const getOtherDocuments = new MakeRequest('Documents', 'get_other_documents')
/** @action request
 * * Insert a description
 * @name getTaxCredit
 * @return {object} - The action object
 */
export const getTaxCredit = new MakeRequest('Documents', 'get_tax_credit')
/** @action request
 * * Insert a description
 * @name getInvoices
 * @return {object} - The action object
 */
export const getInvoices = new MakeRequest('Documents', 'get_invoices')
/** @action request
 * * Insert a description
 * @name getBankStatements
 * @return {object} - The action object
 */
export const getBankStatements = new MakeRequest('Documents', 'get_bank_statements')
// @generator action:route
/** @action
 * * Insert a description
 * @name doGetNewDocuments
 * @return {object} - The payload object
 */
export const doGetNewDocuments = (payload) => createAction(actionTypes.DO_GET_NEW_DOCUMENTS, { payload })
/** @action
 * * Insert a description
 * @name doGetTabs
 * @return {object} - The payload object
 */
export const doGetTabs = (payload) => createAction(actionTypes.DO_GET_TABS, { payload })
/** @action
 * * Insert a description
 * @name doGetTaxCredit
 * @return {object} - The payload object
 */
/** @action
 * * Insert a description
 * @name doResetDownload
 * @return {object} - The payload object
 */
export const doResetDownload = () => createAction(actionTypes.DO_RESET_DOWNLOAD, { })
/** @action
 * * Insert a description
 * @name doGetDownload
 * @return {object} - The payload object
 */
export const doGetDownload = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD, { payload })
/** @action
 * * Insert a description
 * @name doGetTaxCredit
 * @return {object} - The payload object
 */

/** @action
 * * Insert a description
 * @name doGetOtherDocuments

 * @return {object} - The payload object
 */
export const doGetOtherDocuments = (payload) => createAction(actionTypes.DO_GET_OTHER_DOCUMENTS, { payload })
/** @action
 * * Insert a description
 * @name doGetTaxCredit
 * @return {object} - The payload object
 */
export const doGetTaxCredit = (payload) => createAction(actionTypes.DO_GET_TAX_CREDIT, { payload })
/** @action
 *  * Insert a description
 * @name doGetInvoices
 * @return {object} - The payload object
 */
export const doGetInvoices = (payload) => createAction(actionTypes.DO_GET_INVOICES, { payload })
/** @action
 * * Insert a description
 * @name doGetBankStatements
 * @return {object} - The payload object
 */
export const doGetBankStatements = (payload) => createAction(actionTypes.DO_GET_BANK_STATEMENTS, { payload })
